export default __webpack_public_path__ + "static/media/recycling-environment-svgrepo-com.847f9e8e.svg";